import { render, staticRenderFns } from "./YA_HomeContent2.vue?vue&type=template&id=96d615bc&scoped=true"
import script from "./YA_HomeContent2.vue?vue&type=script&lang=js"
export * from "./YA_HomeContent2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d615bc",
  null
  
)

export default component.exports